export enum DadataType {
    Name = 'NAME',
    Address = 'ADDRESS',
    Company = 'PARTY',
    Email = 'EMAIL',
    Bank = 'BANK',
    FmsUnit = 'fms_unit',
}

export interface ISuggestionsOptions {
    disabled?: boolean;
    onSelect?: (response: any) => void;
    formatSelected?: (response: any) => string;
}